import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import ChartAction from '../../../redux/chart/actions'
import Card from '../../../componentsMaterial/Card/Card.jsx'
import CardHeader from '../../../componentsMaterial/Card/CardHeader.jsx'
import CardBody from '../../../componentsMaterial/Card/CardBody.jsx'
import CardIcon from '../../../componentsMaterial/Card/CardIcon.jsx'
import Timeline from '@material-ui/icons/Timeline'
import { Bar } from 'react-chartjs-2'
import chartsStyle from './chartsStyle'
import withStyles from '@material-ui/core/styles/withStyles'
import {
    DatePicker,
    Icon,
    Tooltip,
    Button,
    Dropdown,
    Menu,
    LocaleProvider,
} from 'antd'
import moment from 'moment'
import vi_VN from 'antd/es/locale/vi_VN'

const { MonthPicker, RangePicker } = DatePicker

let dataCount = []
class ChartEventStatisticsByObject extends Component {
    constructor(props) {
        super(props)
        var d = new Date()
        var n = d.getFullYear()
        this.state = {
            options: null,
            starttime: 0,
            endtime: 0,
            type: 0,
            year: n,
            month: 0,
        }
    }
    componentDidMount() {
        const typeSelect = 0
        const month = 0
        const year = 0
        const begintime = 0
        const end_time = 0
        const page_number = 1
        const page_size = 10
        const isrefresh = true
        this.props.loadDataChartEventObject(
            typeSelect,
            month,
            year,
            begintime,
            end_time,
            page_number,
            page_size,
            isrefresh
        )
    }

    componentWillReceiveProps = nextProps => {
        console.log('nextProps', nextProps.chartEventObject)
        // if (nextProps.chartEventObject !== this.props.chartEventObject) {
        const data = nextProps.chartEventObject
        let datapoint = []
        let lstLabel = []
        data.map(value => {
            datapoint.push(value.count_object)
            lstLabel.push(value.event_id)
            dataCount.push(value.count_object)
        })
        this.setState({
            options: {
                labels: lstLabel,
                datasets: [
                    {
                        label: 'Đối tượng',
                        color: 'white',
                        fontColor: 'white',
                        backgroundColor: 'rgba(255,99,132,0.2)',
                        borderColor: 'rgba(255,99,132,1)',
                        borderWidth: 1,
                        hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                        hoverBorderColor: 'rgb(235,90,70)',
                        data: datapoint,
                    },
                ],
            },
        })
        // }
    }
    onChangeTime = e => {
        const starttime = (e[0]._d.valueOf() / 1000) >> 0
        const endtime = (e[1]._d.valueOf() / 1000) >> 0
        this.setState({ starttime, endtime })
        //
        const month = 0
        const year = 0
        const page_number = 1
        const page_size = 10
        const isrefresh = true
        this.props.loadDataChartEventObject(
            this.state.type,
            month,
            year,
            starttime,
            endtime,
            page_number,
            page_size,
            isrefresh
        )
    }
    onLoadMore = () => {
        const { starttime, endtime, type, month, year } = this.state
        const { total, page_number } = this.props.chartEventObjectIndex
        ///

        const typeSelect = 0
        const page_size = 10
        const isrefresh = false
        if (type === 0) {
            this.props.loadDataChartEventObject(
                type,
                0,
                0,
                0,
                0,
                page_number + 1,
                page_size,
                isrefresh
            )
        }
        if (type === 1) {
            this.props.loadDataChartEventObject(
                type,
                month,
                year,
                0,
                0,
                page_number + 1,
                page_size,
                isrefresh
            )
        }
        if (type === 2) {
            this.props.loadDataChartEventObject(
                type,
                0,
                year,
                0,
                0,
                page_number + 1,
                page_size,
                isrefresh
            )
        }
        if (type === 3) {
            this.props.loadDataChartEventObject(
                type,
                0,
                0,
                starttime,
                endtime,
                page_number + 1,
                page_size,
                isrefresh
            )
        }
    }
    onChangeMonth = (date, dateString) => {
        const month = parseInt(dateString.slice(5))
        const year = parseInt(dateString.slice(0, 4))
        this.setState({ year, month })
        const page_size = 10
        const page_number = 1
        const isrefresh = true
        const begintime = 0
        const end_time = 0
        this.props.loadDataChartEventObject(
            this.state.type,
            month,
            year,
            begintime,
            end_time,
            page_number,
            page_size,
            isrefresh
        )
    }
    getNameType = () => {
        switch (this.state.type) {
            case 0:
                return 'Chọn kiểu lọc'
            case 1:
                return 'Chọn theo tháng'
            case 2:
                return 'Chọn theo năm'
            case 3:
                return 'Chọn theo khoảng thời gian'
            default:
                return ''
            // code block
        }
    }
    disabledDate = current => {
        // Can not select days before today and today
        return current && current > moment().endOf('day')
    }
    onSelectYear = dataYear => {
        this.setState({ year: parseInt(dataYear.key) })
        const month = 0
        const begintime = 0
        const end_time = 0
        const page_number = 1
        const page_size = 10
        const isrefresh = true
        this.props.loadDataChartEventObject(
            this.state.type,
            month,
            dataYear.key,
            begintime,
            end_time,
            page_number,
            page_size,
            isrefresh
        )
    }

    render() {
        const { classes, chartEventObject, chartEventObjectIndex } = this.props
        const menu = (
            <Menu>
                <Menu.Item key="1" onClick={() => this.setState({ type: 1 })}>
                    <Icon type="calendar" />
                    Lọc theo tháng
                </Menu.Item>
                <Menu.Item key="2" onClick={() => this.setState({ type: 2 })}>
                    <Icon type="calendar" />
                    Lọc theo năm
                </Menu.Item>
                <Menu.Item key="3" onClick={() => this.setState({ type: 3 })}>
                    <Icon type="calendar" />
                    Lọc theo khoảng thời gian
                </Menu.Item>
                <Menu.Item
                    key="4"
                    onClick={() => {
                        this.setState({ type: 0 })
                        const typeSelect = 0
                        const month = 0
                        const year = 0
                        const begintime = 0
                        const end_time = 0
                        const page_number = 1
                        const page_size = 10
                        const isrefresh = true
                        this.props.loadDataChartEventObject(
                            typeSelect,
                            month,
                            year,
                            begintime,
                            end_time,
                            page_number,
                            page_size,
                            isrefresh
                        )
                    }}
                >
                    <Icon type="calendar" />
                    Tất cả
                </Menu.Item>
            </Menu>
        )
        const lstYear = [
            2018,
            2019,
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026,
            2027,
            2028,
            2029,
            2030,
            2031,
            2032,
            2033,
            2034,
            2035,
            2036,
            2037,
            2038,
            2039,
            2040,
            2041,
            2042,
            2023,
            2044,
            2045,
            2046,
            2047,
            2048,
            2049,
            2050,
        ]
        var d = new Date()
        var n = d.getFullYear()
        const menuYearPicker = (
            <Menu>
                {lstYear.map(year => {
                    if (year <= n) {
                        return (
                            <Menu.Item
                                key={year}
                                onClick={year => this.onSelectYear(year)}
                            >
                                <Icon type="calendar" />
                                {year}
                            </Menu.Item>
                        )
                    }
                })}
            </Menu>
        )

        console.log('this.state.options', this.state.options)
        return (
            <div style={{ width: '100%' }}>
                <Card
                    style={{
                        backgroundImage: `url(${require('../../../resource/image/blur-bg.jpg')}`,
                        backgroundSize: 'initial',
                        backgroundPosition: 'center ',
                        height: 550,
                    }}
                >
                    <CardHeader color="rose" icon>
                        <CardIcon color="rose">
                            <Timeline />
                        </CardIcon>
                        <h4
                            className={classes.cardIconTitle}
                            style={{ color: 'white' }}
                        >
                            Thống kê đối tượng theo sự kiện
                        </h4>
                    </CardHeader>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            flexWrap: 'wrap'
                        }}
                    >
                        <Dropdown overlay={menu}>
                            <Button style={{ marginRight: 20 }}>
                                {this.getNameType()}
                                <Icon type="down" />
                            </Button>
                        </Dropdown>
                        {this.state.type === 2 && (
                            <Dropdown overlay={menuYearPicker}>
                                <Button style={{ marginRight: 20 }}>
                                    {this.state.year}
                                    <Icon
                                        type="down"
                                        style={{ paddingLeft: 10 }}
                                    />
                                </Button>
                            </Dropdown>
                        )}

                        {this.state.type === 1 && (
                            <div>
                                <MonthPicker
                                    onChange={this.onChangeMonth}
                                    disabledDate={this.disabledDate}
                                    style={{ padding: 10 }}
                                    placeholder="Chọn tháng"
                                />
                            </div>
                        )}

                        {this.state.type === 3 && (
                            <div>
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    renderExtraFooter={() =>
                                        'Hiển thị biểu đồ theo thời gian'
                                    }
                                    onChange={this.onChangeTime}
                                    placeholder={[
                                        'Thời gian đầu',
                                        'Thời gian cuối',
                                    ]}
                                    showTime
                                    style={{ padding: 10 }}
                                />
                            </div>
                        )}
                    </div>

                    <CardBody>
                        <div>
                            <text style={{ color: 'white' }}>
                                Số lượng đối tượng
                            </text>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '100%',
                                    alignItems: 'flex-end',
                                }}
                            >
                                <div
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    {this.state.options && (
                                        <Bar
                                            data={this.state.options}
                                            height={400}
                                            width={500}
                                            options={{
                                                defaultFontColor: 'white',
                                                maintainAspectRatio: false,
                                                legend: {
                                                    display: true,
                                                    labels: {
                                                        fontColor: 'white',
                                                    },
                                                },
                                                scales: {
                                                    yAxes: [
                                                        {
                                                            ticks: {
                                                                fontColor:
                                                                    'white',
                                                            },
                                                        },
                                                    ],
                                                    xAxes: [
                                                        {
                                                            ticks: {
                                                                fontColor:
                                                                    'white',
                                                            },
                                                        },
                                                    ],
                                                },

                                                tooltips: {
                                                    callbacks: {
                                                        label: function(
                                                            tooltipItem
                                                        ) {
                                                            return (
                                                                ' ' +
                                                                chartEventObject[
                                                                    tooltipItem
                                                                        .index
                                                                ].event_name +
                                                                ': ' +
                                                                tooltipItem.value +
                                                                ' Đối tượng liên quan'
                                                            )
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    )}
                                </div>

                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    {chartEventObjectIndex.page_number <
                                        chartEventObjectIndex.total / 10 && (
                                        <Tooltip
                                            placement="right"
                                            title="Tải thêm dữ liệu"
                                        >
                                            <Button
                                                type="link"
                                                style={{
                                                    fontSize: 40,
                                                    paddingBottom: 200,
                                                }}
                                                onClick={() =>
                                                    this.onLoadMore()
                                                }
                                            >
                                                <Icon type="caret-right" />
                                            </Button>
                                        </Tooltip>
                                    )}
                                    <text
                                        style={{ padding: 10, color: 'white' }}
                                    >
                                        Sự kiện
                                    </text>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        chartEventObject: state.chartReducer.chartEventObject,
        chartEventObjectIndex: state.chartReducer.chartEventObjectIndex,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadDataChartEventObject: (
            type,
            month,
            year,
            begin_time,
            end_time,
            page_number,
            page_size,
            isRefresh
        ) => {
            dispatch(
                ChartAction.action.loadDataChartEventObject(
                    type,
                    month,
                    year,
                    begin_time,
                    end_time,
                    page_number,
                    page_size,
                    isRefresh
                )
            )
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(chartsStyle)(ChartEventStatisticsByObject))
